/**
 * Verifica se string passada por parâmetro não é vazia.
 * @param {string} value
 * @returns {boolean}
 */
export const isEmptyString = (value) => value.trim().length === 0;
